// 打乱数组顺序的工具函数
export function shuffle<T>(array: T[]): T[] {
  const result = [...array];
  for (let i = result.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [result[i], result[j]] = [result[j], result[i]];
  }
  return result;
}

// 其他游戏相关工具函数也可以放在这里
export const calculateAccuracy = (total: number, wrong: number): number => {
  return Math.round(((total - wrong) / total) * 100);
};
